import { type BTServiceFileUpload } from "legacyComponents/FileUploadContainer.types";

import { BTSelectItem } from "types/apiResponse/apiResponse";

import {
    AddressEntity,
    type AddressFormValues,
    type IHasAddress,
} from "commonComponents/entity/address/Address/Address.api.types";

export enum OutboundPaymentWizardSteps {
    CompanyInfo = 0,
    PaymentPreview = 1,
    AddBankAccount = 2,
    Confirmation = 3,
}

export enum OutboundPaymentsDefaultMemo {
    BillId = 1,
    BillTitle = 2,
    BillDescription = 4,
    BillDetails = BillId | BillTitle | BillDescription,
    POIdNumber = 8,
    POTitle = 16,
    PODetails = POIdNumber | POTitle,
    JobName = 32,
}

export class OutboundPaymentSetupData implements IHasAddress {
    constructor(data: any) {
        this.address = new AddressEntity(data.address);
        this.builderName = data.builderName;
        this.builderLogoUrl = data.builderLogoUrl;
        this.paymentExpiration = data.paymentExpiration;
        this.signatureString = data.signatureString;
        this.memoOptions =
            data.selectedMemoList === null
                ? []
                : data.selectedMemoList.options.map((x: any) => new BTSelectItem(x));
        this.selectedMemoOptions =
            data.selectedMemoList === null ? [] : data.selectedMemoList.value;
        this.canLinkBankAccounts =
            (data as { canLinkBankAccounts?: boolean }).canLinkBankAccounts ?? false;
    }

    address: AddressEntity;
    builderLogoUrl: string;
    builderName: string;
    paymentExpiration: number;
    signatureString: string;
    memoOptions: BTSelectItem[];
    selectedMemoOptions: number[];
    canLinkBankAccounts: boolean;
}

export enum BankAccountVerificationStatus {
    NotAdded = 0,
    Verified = 1,
    PendingAutomaticVerification = 2,
    PendingManualVerification = 3,
}

export interface ICreateOutboundPaymentAccountRequest {
    address: AddressFormValues;
    companyName: string;
    logoTempFile: BTServiceFileUpload | null;
    signatureString: string;
    signatureTempFile: BTServiceFileUpload | null;
    paymentExpiration: number;
    memoIds: number[] | undefined;
}

export type OutboundPaymentWizardActions =
    | "next"
    | "previous"
    | "cancel"
    | "saveBankAccount"
    | "addBankAccount"
    | undefined;
